const CYCLE_DEFAULT_DURATION = [
	{ maxVideoDuration: 15, cycleDuration: 1 },
	{ maxVideoDuration: 30, cycleDuration: 2 },
	{ maxVideoDuration: 300, cycleDuration: 5 },
	{ maxVideoDuration: 600, cycleDuration: 10 },
	{ maxVideoDuration: 1200, cycleDuration: 15 },
	{ maxVideoDuration: Infinity, cycleDuration: 60 }
];

export function getDefaultDuration(videoDuration: number): number {
	const config = CYCLE_DEFAULT_DURATION.find((item) => videoDuration <= item.maxVideoDuration);
	const defaultDuration = config?.cycleDuration ?? 60;

	return defaultDuration;
}

export function getMinCycleDuration(videoDuration?: number): number {
	if (!videoDuration) {
		return 1.0;
	}

	const minDuration = videoDuration < 15 ? 0.999 : 1.0;

	return minDuration;
}
